import React from "react";

interface Props {
  size?: number;
  color?: string;
}

const GitHubIcon = ({ size = "16", color = "currentColor" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>GitHub icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99962 0.0078125C3.58249 0.0078125 0.000244141 3.58958 0.000244141 8.00818C0.000244141 11.5423 2.29231 14.5411 5.47133 15.5994C5.87159 15.6726 6.01746 15.4256 6.01746 15.2134C6.01746 15.0233 6.0105 14.5204 6.00632 13.853C3.78105 14.3362 3.31155 12.7804 3.31155 12.7804C2.94762 11.8561 2.4231 11.6101 2.4231 11.6101C1.69673 11.114 2.47809 11.1238 2.47809 11.1238C3.28107 11.1803 3.70344 11.9484 3.70344 11.9484C4.41704 13.1708 5.57608 12.8177 6.03184 12.6129C6.10451 12.0963 6.31129 11.7436 6.53965 11.5437C4.76328 11.3414 2.89554 10.6553 2.89554 7.58975C2.89554 6.71605 3.20741 6.00244 3.71915 5.44306C3.6366 5.24071 3.36211 4.4274 3.79781 3.32581C3.79781 3.32581 4.46916 3.11072 5.99754 4.14552C6.6355 3.96822 7.32012 3.87982 8.00033 3.87638C8.68003 3.87916 9.36416 3.96826 10.0031 4.14552C11.5305 3.11072 12.2009 3.32581 12.2009 3.32581C12.6375 4.4274 12.3629 5.24071 12.2809 5.44306C12.7936 6.00244 13.1031 6.71605 13.1031 7.58975C13.1031 10.6632 11.2324 11.3394 9.45059 11.5373C9.7374 11.7844 9.99328 12.2726 9.99328 13.0191C9.99328 14.0882 9.98353 14.9511 9.98353 15.2134C9.98353 15.4275 10.1279 15.6765 10.5336 15.5984C13.7102 14.5381 16.0002 11.5418 16.0002 8.00818C16.0002 3.58958 12.418 0.0078125 7.99941 0.0078125"
        fill={color}
      />
    </svg>
  );
};

export default GitHubIcon;
